module.exports = __webpack_public_path__ + "static/media/image1.5cbd3bc4.png";